/**
 * Trust-strip formatting helpers (S24 polish). A sub-millisecond preview —
 * routine against a mock/local engine — rounded to `0 ms`, which reads like a
 * broken measurement rather than "instant". Clamp the display instead.
 */

/** `0.4 ms` → `<1 ms`; anything else rounds to whole milliseconds. */
export function formatPreviewDuration(durationMs: number): string {
  if (!Number.isFinite(durationMs) || durationMs < 0) return '<1 ms';
  return durationMs < 1 ? '<1 ms' : `${Math.round(durationMs)} ms`;
}
